import React, { useState, useEffect } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import signupsvg from "../assets/image/signupsvg.svg";
import handupsvg from "../assets/image/handsupsvg.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Volunteering() {
  const [showModal, setShowModal] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [error, setError] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [role, setRole] = useState("");
  const [hours, setHours] = useState("");
  const [skills, setSkills] = useState("");
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedUser) {
      const name =
        storedUser.name ||
        `${storedUser.first_name || ""} ${storedUser.last_name || ""}`.trim() ||
        storedUser.username ||
        storedUser.email?.split("@")[0] ||
        "User";

      setUserName(name);
      setUserEmail(storedUser.email || "");
    }
  }, []);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const safeJson = async (response) => {
    const text = await response.text();
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  };

  useEffect(() => {
    const fetchOpportunities = async () => {
      setLoading(true);
      setError("");

      try {
        const token = localStorage.getItem("authToken");
        const response = await fetch(
          `${TEST_BASE_URL}/volunteer-opportunities`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to load volunteer opportunities.");
        }

        const result = await response.json();
        setOpportunities(result?.data?.data || []);
      } catch (err) {
        setError("Failed to load volunteer opportunities. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchOpportunities();
  }, [TEST_BASE_URL]);

  const openModal = (opportunity) => {
    setSelectedOpportunity(opportunity);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOpportunity(null);

    setRole("");
    setHours("");
    setSkills("");
    setAgree1(false);
    setAgree2(false);
  };

  const handleSignupSubmit = async (e) => {
    e.preventDefault();

    if (!agree1 || !agree2) {
      return toast.error("You must agree to all conditions.");
    }

    if (!role || !hours) {
      return toast.error("Please select a role and available hours.");
    }

    try {
      setSubmitLoading(true);
      const token = localStorage.getItem("authToken");
      const opportunityId = selectedOpportunity?.id;

      if (!opportunityId) {
        return toast.error("Opportunity ID is missing.");
      }

      const payload = {
        name: userName,
        email: userEmail,
        role_selected: role,
        hours_selected: hours,
        skills: skills || "",
        confirm_availability: agree1 ? 1 : 0,
        agree_training: agree2 ? 1 : 0,
      };

      const response = await fetch(
        `${TEST_BASE_URL}/volunteer-opportunities/${opportunityId}/signups`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await safeJson(response);

      if (!response.ok) {
        const errorMsg =
          data?.errors && typeof data.errors === "object"
            ? Object.values(data.errors).flat().join(" ")
            : data?.message || "Signup failed. Please try again.";

        console.error(" Error:", errorMsg);
        return toast.error(errorMsg);
      }

      toast.success("You have successfully signed up for volunteering!");
      closeModal();
    } catch (err) {
      console.error(" Submission error:", err);
      toast.error("Failed to submit form. Please try again.");
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div className="bottom-content">
          <div className="prayer-title">
            <span>Volunteering</span>
          </div>

          <div className="volunteer-head">
            <span className="fs-5">Current Volunteer Opportunities</span>
            <a href="/allvolunteer">
              <u>View All</u>
            </a>
          </div>

          {loading && <p>Loading volunteer opportunities...</p>}
          {error && <p className="text-danger">{error}</p>}

          {!loading && !error && (
            <div className="row mt-4 singlesrow">
              {opportunities.length > 0 ? (
                opportunities.map((op) => (
                  <div className="col-md-4" key={op.id}>
                    <div className="volunteer-card">
                      <h6>{op.title || op.name}</h6>
                      <span>
                        <b>Roles Needed</b>:{" "}
                        {op.roles_needed || "Not specified"}
                      </span>
                      <span>
                        <b>Special Requirements</b>:{" "}
                        {op.special_requirements || "None"}
                      </span>
                      <div>{op.hours_required || "N/A"}+ hours</div>
                      <div className="volunteer-button">
                        <button onClick={() => openModal(op)}>Sign Up</button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No volunteer opportunities found.</p>
              )}
            </div>
          )}

          <div className="volunteer-signup row">
            <div className="col-md-5">
              <img src={signupsvg} alt="" />
              <h5 className="py-4">Sign Up to Serve</h5>
              <ul>
                <li>Confirm your bio details</li>
                <li>Choose your preferred time slot</li>
                <li>Accept the volunteer commitment agreement</li>
              </ul>
            </div>

            <div className="col-md-5">
              <img src={handupsvg} alt="" />
              <h5 className="py-4">Manage Your Volunteering</h5>
              <ul>
                <li>Update availability anytime</li>
                <li>View upcoming commitments in portal</li>
                <li>Get notified of assigned roles</li>
              </ul>
            </div>

            <a href="/managesignup" className="volunteerSignup">
              My Volunteer Signups
            </a>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="rsvp-backdrop">
          <div className="rsvp-box">
            <h4 className="pb-1">Sign Up / Volunteer</h4>
            <h6>{selectedOpportunity?.title || "Volunteer Signup"}</h6>

            <form onSubmit={handleSignupSubmit}>
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                value={userName}
                readOnly
              />

              <label>Email</label>
              <input
                type="email"
                className="form-control"
                value={userEmail}
                readOnly
              />

              <label>Select volunteer role</label>
              <select
                className="form-control"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="">Select Available Roles</option>
                <option value="Chorister">Chorister</option>
                <option value="Media">Media</option>
                <option value="Protocol">Protocol</option>
                <option value="Welfare">Welfare</option>
                <option value="Logistics">Logistics</option>
              </select>

              <label>Available hours</label>
              <select
                className="form-control"
                value={hours}
                onChange={(e) => setHours(e.target.value)}
              >
                <option value="">Choose Hours</option>
                <option value="Morning">Morning</option>
                <option value="Afternoon">Afternoon</option>
                <option value="Evening">Evening</option>
              </select>

              <label>Relevant skills or experience</label>
              <textarea
                rows="5"
                className="form-control"
                value={skills}
                onChange={(e) => setSkills(e.target.value)}
              ></textarea>

              <div className="confirm">
                <input
                  type="checkbox"
                  checked={agree1}
                  onChange={() => setAgree1(!agree1)}
                />
                <label>
                  I confirm my availability and willingness to serve.
                </label>
              </div>

              <div className="confirm">
                <input
                  type="checkbox"
                  checked={agree2}
                  onChange={() => setAgree2(!agree2)}
                />
                <label>I agree to attend required briefings or training.</label>
              </div>

              <div className="modalbutton">
                <button
                  type="button"
                  onClick={closeModal}
                  disabled={submitLoading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="text-white"
                  disabled={submitLoading}
                >
                  {submitLoading ? "Submitting..." : "Sign Up"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}

export default Volunteering;
